import "./PricingHotelRevenueManagement.module.css";
import Header from "@/reusable_sections/Header";
import Pricinghero from "./sections/Pricinghero";
import ConsultingPricing from "./sections/ConsultingPricing";
import Financialfaq from "./sections/Financialfaq";
import Calculator from "./sections/Calculator";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function PricingHotelRevenueManagementPage() {
  return <div>
      <Header />
      <Pricinghero />
      <ConsultingPricing />
      <Financialfaq />
      <Calculator />
      <Consultation />
      <Footer />
    </div>;
}